<div
  class="h-screen w-full bg-ladder-purpleLight flex flex-col justify-center items-center overflow-y-auto px-4 py-12"
>
  <img class="mb-4 min-[1200px]:fixed top-12 left-10 transition-all hover:scale-105 hover:-rotate-12" src="assets/imgs/logo.svg" alt="logo startup ladder" />
  <div
    class="bg-white w-full max-w-[576px] h-full rounded-3xl shadow-lg pb-4 pt-8 px-7"
  >
    <router-outlet></router-outlet>
  </div>
</div>
